import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { RIValidationDetalleContent } from './components/RIValidationDetalleContent';

export default function RIValidationDetalle() {
    return (
        <>
            <MainContent
                component={<RIValidationDetalleContent />}
                titulo='Pantalla Verificar'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
